<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-file-document"></i>
            </span> บันทึกการลาของบุคลากร
        </h4>
    </div>

    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body  text-center">
                    <div style="float: right;">
                        <select id="exampleFormControlSelect1" name="year_select" class="form-control form-control-lg"
                            style="width: 150px; height: 40px;" (change)="select_year()" [(ngModel)]="year_select">
                            <option *ngFor="let year of years" value="{{year}}">{{year}}</option>
                        </select><br>
                    </div>
                    <div id="print-section">
                        <div class="text-left" style="text-align: center;">
                            <h4>รายงานการลาของบุคลากรกองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่ ประจำปี {{year_select}}</h4>
                        </div>
                        <div class="table-responsive" style="min-height: 50vh;">
                            <table class="table table-hover table-bordered"
                                style="border: 1px solid #ebedf2; border-collapse: collapse; width: 100%; cursor: context-menu;">
                                <thead>
                                    <tr>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;"
                                            rowspan="2">ชื่อ -
                                            สกุล</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;"
                                            colspan="6">
                                            ประเภทการลา(วัน)</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;"
                                            rowspan="2">
                                            หมายเหตุ</th>
                                    </tr>
                                    <tr>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            ลาพักผ่อน</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            ลาป่วย</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            ลากิจ</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            ลาคลอด</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            มาสาย</th>
                                        <th scope="col"
                                            style="padding: 10px; font-weight: 500;vertical-align: middle;border: 1px solid #ebedf2;text-align: center;">
                                            ขาดราชการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data_select| paginate : {
                                        itemsPerPage: tableSize,
                                        currentPage: page,
                                        totalItems: count
                                      };">
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: left;">
                                            {{item.person_name}}
                                        </td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.recess}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.sick}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.kij}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.deliver}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.late}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center;">
                                            {{item.broken}}</td>
                                        <td style="padding: 10px; border: 1px solid #ebedf2;text-align: center; vertical-align: middle;">
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_recess < 0">ลาพักผ่อนเกินกำหนดแล้ว</p>
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_sick < 0">ลาป่วยเกินกำหนดแล้ว</p>
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_kij < 0">ลากิจเกินกำหนดแล้ว</p>
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_deliver < 0">ลาคลอดเกินกำหนดแล้ว</p>
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_late < 0">มาสายเกินกำหนดแล้ว</p>
                                            <p style="color: red; margin-bottom: 0;" *ngIf=" item.re_broken < 0">ขาดราชการเกินกำหนดแล้ว</p></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right" style="margin-top: 5px;text-align: right;">
                                <p style="font-size: 10pt;">ข้อมูล ณ วันที่ {{today_date}}</p>
                            </div>
                            <!-- <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                                (pageChange)="onTableDataChange($event)" style="text-align: center;">
                            </pagination-controls> -->
                            <!-- <h3 *ngIf="list_report.length == 0 " style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3> -->
                        </div>
                    </div>
                    <br>
                    <div class="text-center">
                        <button class="btn btn-gradient-danger btn-icon-text" style="margin-left: 20px;"
                            printTitle="รายงานการลาบุคลากร-{{year_select}}" [useExistingCss]="false"
                            printSectionId="print-section" ngxPrint><i
                                class="mdi mdi-file-pdf btn-icon-prepend"></i>พิมพ์รายงาน</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>